import { render, staticRenderFns } from "./PricePlanCreateModal.vue?vue&type=template&id=8036e3b2&scoped=true&"
import script from "./PricePlanCreateModal.vue?vue&type=script&lang=js&"
export * from "./PricePlanCreateModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./PricePlanCreateModal.vue?vue&type=style&index=1&id=8036e3b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8036e3b2",
  null
  
)

export default component.exports